const IconBack = () => {
    return (
        <svg viewBox="0 0 24 24">
            <path d="M4,15V9H12V4.16L19.84,12L12,19.84V15H4Z"></path>
        </svg>        
    );
}
  
export default IconBack;